const duration = (startDate: string, endDate: string | null) => {
    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date();

    let seconds = end.getTime() - start.getTime();
    // hours
    const hours = Math.floor(seconds / 3600000);
    seconds = seconds % 3600000;
    const minutes = Math.floor(seconds / 60000);


    let result = ''
    if (hours > 0) {
        if (hours > 1) {
            result = result + `${hours}hrs `;
        } else {
            result = result + `${hours}hr `;
        }
    }
    if (hours === 0 && minutes === 0) {
        return 'less than a minute';
    }
    if (minutes > 1) {
        return result + `${minutes}mins`;
    }
    return result + `${minutes}min`;
}

export const durationTotal = (startDate: string, endDate: string) => {
    return `${duration(startDate, endDate)} total`;
}

export const durationSince = (startDate: string) => {
    return `${duration(startDate, null)}`;
}

export const isCheckedIn = (lastSiteLogin: string | undefined, lastSiteLogout: string | undefined): boolean => {
    const checkin = lastSiteLogin ? new Date(lastSiteLogin) : null;
    const checkout = lastSiteLogout ? new Date(lastSiteLogout) : null;

    if (!checkin && !checkout) {
        // Worker has never checked in or out.
        return false;
    }

    if (checkin && !checkout) {
        // Worker checked in
        return true;
    }

    if (checkin && checkout && checkin > checkout) {
        // Checkout was before checkin so checked in right now
        return true;
    }

    return false;
}
